exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".submit-btn[data-v-a6dbb39a] {\n  margin-bottom: 0.7em;\n}\n", ""]);

// exports
